
<span class="page-flexer">
  <!-- <bhub-sidebar class="flex-1"></bhub-sidebar> -->


  <div class="flex-2 content mat-elevation-z4">
    <router-outlet></router-outlet>
  </div>
</span>
